import report from '@/api/report/finance'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  getVendor(context, attributes = {}) {
    return report.vendor()
  },
  payToVendor(context, data) {
    return report.payToVendor(data)
  },
  payToVendorExcel(context, data) {
    return report.payToVendorExcel(data)
  },
  incomeStatementDetail(context, data) {
    return report.incomeStatementDetail(data)
  },
  incomeStatementDetailExcel(context, data) {
    return report.incomeStatementDetailExcel(data)
  },
  grossProfit(context, data) {
    return report.grossProfit(data)
  },
  grossProfitExcel(context, data) {
    return report.grossProfitExcel(data)
  },
  // generate account receivable
  accountReceivable(context, attributes = {}) {
    return report.accountReceivable({ params: attributes })
  },
  // generate account receivable
  accountReceivableExcel(context, data) {
    return report.accountReceivableExcel(data)
  },
  // generate yearly sold by sale type
  yearlySoldBySaleType(context, attributes = {}) {
    return report.yearlySoldBySaleType({ params: attributes })
  },
  // generate account receivable
  yearlySoldBySaleTypeExcel(context, data) {
    return report.yearlySoldBySaleTypeExcel(data)
  },
  // generate cash collection by cashier
  cashCollectionByCashier(context, attributes = {}) {
    return report.cashCollectionByCashier({ params: attributes })
  },
  // export excel cash collection by cashier
  cashCollectionByCashierExcel(context, data) {
    return report.cashCollectionByCashierExcel(data)
  },
  // generate yearly sold by sale type
  customerSalesByMonth(context, attributes = {}) {
    return report.customerSalesByMonth({ params: attributes })
  },
  // generate account receivable
  customerSalesByMonthExcel(context, data) {
    return report.customerSalesByMonthExcel(data)
  },
  grossProfitCustomerExcel(context, data) {
    return report.grossProfitCustomerExcel(data)
  },
  grossProfitCustomer(context, data) {
    return report.grossProfitCustomer(data)
  },
  productCategory(context) {
    return report.productCategory()
  },
  productGroup(context, attributes = {}) {
    return report.productGroup({ params: attributes })
  },
  productProfileLocation(context, attributes = {}) {
    return report.productProfileLocation({
      params: attributes
    })
  },
  getBranch(context, attributes = {}) {
    return report.getBranch({ params: attributes })
  },
  customerProfile(context) {
    return report.customerProfile()
  },
  customerType(context) {
    return report.customerType()
  },
  saleContractExcel(context, data) {
    return report.saleContractExcel(data)
  },
  saleContract(context, data) {
    return report.saleContract(data)
  },
  accountPayable(context, data) {
    return report.accountPayable(data)
  },
  accountPayableExcel(context, data) {
    return report.accountPayableExcel(data)
  },
  cashCollectionRestaurantSaleByCashier(context, attributes = {}) {
    return report.cashCollectionRestaurantSaleByCashier({ params: attributes })
  },
  cashCollectionRestaurantSaleByCashierExcel(context, data) {
    return report.cashCollectionRestaurantSaleByCashierExcel(data)
  },
}